import * as angular from 'angular';

import './layout';
import './autenticacao';
import './abrir-chamado';
import './detalhe-chamado';
import './meus-chamados';

import ui from 'compartilhado/plugins/ui.plugin'
import filters from 'compartilhado/plugins/filters.plugin'

angular.module('app.modules', [
    'layoutMdl',
    'autenticacaoMdl',
    'abrirChamadoMdl',
    'detalheChamadoMdl',
    'meusChamadosMdl'
])

.use( ui, 'md' )
.use( filters )


// WEBPACK FOOTER //
// ./src/modules/index.js